export default {"src":"/_next/static/media/step2-idcard-sitter.00577642.svg","height":176,"width":224,"blurWidth":0,"blurHeight":0};